const icon = "_araikqg6kp";

export { icon };
import "./button.style.linaria.module.css";
//# sourceMappingURL=button.style.js.map
